import {WidgetCard} from './WidgetCard';
import {WidgetContent} from './WidgetContent';
import {WidgetHeader} from './WidgetHeader';

export const Widget = {
  Card: WidgetCard,
  Header: WidgetHeader,
  Content: WidgetContent,
} as const;
